import axios from "axios";
import { AuthenticatedRepository } from "..";
import { Authenticate } from "../../domain/authentication";
import { LoggerFactory } from "../../utilities/logger";
import { UserTranslator } from "../user/translators";
import { IAuthenticateBean, IAuthenticateRequestBean } from "./beans";

export class AuthenticationRepository extends AuthenticatedRepository {
  private readonly _logger = LoggerFactory.getLogger();
  
  constructor(getToken: () => string) {
    super(getToken);
  }

  async getAuthentication(id: string, password: string): Promise<Authenticate> {
    const url = "/api/account/login";
    const request = this.createAuthenticateRequestBean(id, password);
    this._logger.debug("[POST] " + url);
    const result = await axios.post(url, request);
    this._logger.debug(result.data);
    return this.toAuthenticate(result.data);
  }

  async discardAuthentication(): Promise<void> {
    const url = "/api/account/logout";
    await this.post(url);
  }

  private createAuthenticateRequestBean(id: string, password: string): IAuthenticateRequestBean {
    return {
      userId: id,
      password: password,
    };
  }

  private toAuthenticate(bean: IAuthenticateBean): Authenticate {
    if (!bean) { throw new Error("bean is empty!!!"); }
    const result = new Authenticate();
    result.token = bean.token;
    result.user = UserTranslator.toUser(bean.user);
    return result;
  }
}
